// extracted by mini-css-extract-plugin
export default {"item":"ConfigurationList_item__-4hBN","ListContainer":"ConfigurationList_ListContainer__IT+uY"};